import React from "react"
import { CloudinaryImage } from "@cloudinary/url-gen"
import { AdvancedImage } from "@cloudinary/react"
import { fill } from "@cloudinary/url-gen/actions/resize"

import { lazyLoadPreset } from "../../utils/cloudinaryImageUtils"
import Section from "./product-marketing/Section"
import ImageTextBlock from "./product-marketing/ImageTextBlock"

const TWCContent = () => (
  <Section head="Texas Workforce Commission Funding Program">
    <ImageTextBlock
      image={
        <AdvancedImage
          cldImg={new CloudinaryImage("logos/twc-logo-1250x1250_ii96hi", {
            cloudName: "coastline-academy",
          })
            .resize(fill(300))
            .quality(80)
            .format("auto")}
          plugins={[lazyLoadPreset]}
          alt="TWC Logo"
          width={300}
        />
      }
    >
      <p>
        The TWC has launched the Driver&apos;s Education Funding Program to
        support young adults transitioning from foster care and individuals
        facing homelessness. This program is designed to eliminate
        transportation barriers by covering the full cost of driver&apos;s
        education classes for eligible participants. By helping individuals
        obtain their driver&apos;s licenses, the program aims to increase job
        opportunities and support their journey toward self-sufficiency.
      </p>

      <p>How It Works:</p>
      <ul>
        <li>
          Complete the TWC Driver Education Funding Program{" "}
          <a
            href="https://www.twc.texas.gov/sites/default/files/wf/docs/driver-education-application-twc.docx"
            target="_blank"
            rel="noreferrer"
          >
            application
          </a>
          .
        </li>
        <li>
          Fill out the{" "}
          <a
            href="https://www.twc.texas.gov/sites/default/files/wf/docs/eligibility-verification-form-driver-education-twc.docx"
            target="_blank"
            rel="noreferrer"
          >
            Eligibility Requirement Forms
          </a>
          .
        </li>
        <li>
          Submit both forms to{" "}
          <a href="mailto:drivereducationprogram@twc.texas.gov">
            DriverEducationProgram@twc.texas.gov
          </a>
          .
        </li>
        <li>Upon TWC approval, Coastline will receive a notification.</li>
        <li>
          Schedule your driver’s education services directly with Coastline.
        </li>
        <li>TWC will handle payment to Coastline.</li>
      </ul>
    </ImageTextBlock>
  </Section>
)

export default TWCContent
